import { useContext, useEffect, useMemo } from 'react';
import core from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { SELECTOR_STUB } from 'app-constants';
import { Modules, useAsyncModule } from 'async-modules';
import { useMemoSelector } from 'hooks';
import { BettingReadyIndicatorContext } from 'modules/betting-ready-indicator';

const {
    viewport: {
        selectors: { selectIsCompact },
    },
    utils: { isFetchFinished },
} = core;

interface Output {
    isCompact: boolean;
}

const makePropsSelector = (
    filtersModule: Modules['filters']['default'] | null
) => {
    const selectCategorizerFetchStatus =
        filtersModule?.selectors.selectCategorizerFetchStatus ?? SELECTOR_STUB;

    return createStructuredSelector({
        fetchStatus: selectCategorizerFetchStatus,
        isCompact: selectIsCompact,
    });
};

const useOutrights = (): Output => {
    const filtersModule = useAsyncModule('filters');

    const selectProps = useMemo(() => makePropsSelector(filtersModule), [
        filtersModule,
    ]);

    const { isCompact, fetchStatus } = useMemoSelector(selectProps, {}, [
        filtersModule,
    ]);

    const readyIndicator = useContext(BettingReadyIndicatorContext);

    useEffect(() => {
        if (!fetchStatus) return;

        if (isFetchFinished(fetchStatus)) {
            readyIndicator.setReady('hasData');
        }
    }, [fetchStatus, readyIndicator]);

    return {
        isCompact,
    };
};

export default useOutrights;
